<div class="context-menu">
  <app-lasso-tool
    class="context-menu-item"
    [settings]="lassoToolSettings"
    [useHotKeys]="false"
    (toolActivated)="onActivateTool()"
  ></app-lasso-tool>
  <app-brush-tool
    class="context-menu-item"
    [settings]="brushToolSettings"
    [useHotKeys]="false"
    (toolActivated)="onActivateTool()"
  ></app-brush-tool>
  <app-eraser-tool
    class="context-menu-item"
    [settings]="eraserToolSettings"
    [useHotKeys]="false"
    (toolActivated)="onActivateTool()"
  ></app-eraser-tool>
</div>
